import classNames from 'classnames';
import { observer } from 'mobx-react';

import { useStores } from '../../stores/useStores';
import DailyMissionErrorBoundary from '../DailyMissions/components/DailyMissionErrorBoundry';
import { DailyMissionsProgressBar } from '../DailyMissions/components/DailyMissionsProgressBar';
import { FeatureFlag } from '../FeatureFlag/FeatureFlag';
import { HomeWidgets } from '../widgets/homeWidgets/HomeWidgets';

import classes from './GamesHero.module.scss';
import { GenericHeader } from './headers/GenericHeader';

export const GamesHero = observer(() => {
  const { dailyMissionsStore, uiStore } = useStores();
  const { currentDailyMission } = dailyMissionsStore;

  const showDailyMissionProgressBar =
    currentDailyMission && ['ACTIVE', 'COMPLETED'].includes(currentDailyMission.status);

  return (
    <div className={classes.gamesHero}>
      <GenericHeader />
      <div className={classes.homeWidgetsContainer}>
        <div className={classes.homeWidgetsPosition}>
          <HomeWidgets />
        </div>
      </div>
      {showDailyMissionProgressBar && (
        <FeatureFlag defaultValue={true} flagKey="daily_missions_feature">
          <DailyMissionErrorBoundary>
            <div
              className={classNames(classes.dailyMissionWidget, { [classes.withPresedence]: !uiStore.isDialogOpen })}
            >
              <DailyMissionsProgressBar />
            </div>
          </DailyMissionErrorBoundary>
        </FeatureFlag>
      )}
    </div>
  );
});
